import { Button } from '@material-ui/core';
import React from 'react';

import useProductsExport from 'core/hooks/useProductsExport';

export default function ProductExportButton() {
  const url = useProductsExport();

  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      variant="contained"
      color="secondary"
    >
      Hae tuotelista
    </Button>
  );
}
